var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4C3A",
    fillRule: "evenodd",
    d: "M30.018 28.667H0V0h30.018v28.667",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    d: "M15.372 4.377c.452.213.358.489.219 1.793-.142 1.345-.618 3.802-1.535 6.219-.918 2.413-2.28 4.784-3.467 6.539-1.186 1.756-2.201 2.897-2.975 3.556-.777.659-1.314.835-1.665.893-.348.058-.506 0-.6-.177-.094-.176-.127-.466-.046-.82.079-.35.268-.76.804-1.285.541-.527 1.426-1.172 2.661-1.771 1.235-.6 2.817-1.156 4.116-1.537a30.03 30.03 0 0 1 3.197-.746 23.98 23.98 0 0 1 2.391-.337 14.241 14.241 0 0 1 2.186 0c.712.06 1.408.175 2.011.323.6.146 1.108.321 1.551.601.442.276.823.657 1.012 1.083.192.423.192.893.033 1.228-.158.337-.476.541-.839.66a2.103 2.103 0 0 1-1.267 0c-.49-.148-1.062-.47-1.662-.894-.601-.425-1.235-.952-2.057-1.771a35.417 35.417 0 0 1-2.692-3.013c-.854-1.083-1.553-2.136-2.028-3.029a11.317 11.317 0 0 1-.933-2.355c-.206-.733-.364-1.464-.427-2.122s-.034-1.245.03-1.714c.063-.466.16-.82.317-1.055.158-.23.381-.35.539-.408s.254-.058.348-.073c.094-.015.188-.044.333 0 .138.042.321.154.504.268"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.022936f5.svg";
export { ForwardRef as ReactComponent };